module.exports = require('./helpers/bundle-url').getBundleURL('1i6XA') + "logo-dark.eefe0b7f.svg";